// src/App.js
import "./App.css";
import Navbar from "./components/Navbar";
import Intro from "./components/Intro";
import AboutSection from "./components/AboutSection";
import ImageSection from "./components/ImageSection";
import FeaturesSection from "./components/FeaturesSection";
import ImageSection2 from "./components/ImageSectionII";
import BarrioSection from "./components/BarrioSection";
import DoubleImageSection from "./components/DoubleImageSection";
import ProyectoSection from "./components/ProyectoSection";
import CalidadesSection from "./components/CalidadesSection";
import ImageSection3 from "./components/ImageSectionIII";
import NosotrosSection from "./components/NosotrosSection";
import Outro from "./components/Outro";
import ImageSectionVert from "./components/ImageSectionVert";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Intro />
      <AboutSection />
      <ImageSection />
      <ImageSectionVert />
      <FeaturesSection />
      <ImageSection2 />
      <BarrioSection />
      <DoubleImageSection />
      <CalidadesSection />
      <ProyectoSection />
      <ImageSection3 />
      <NosotrosSection />
      <Outro />
      {/* We'll add more sections later */}
    </div>
  );
}

export default App;
